// Evento em destaque, usado no pop-up e na secção da Home.
// Para mudar de evento, basta alterar estes dados (e as datas em utils/campanhas.js).
export const EVENTO = {
  chave: 'ritual_outono',
  artigo: '/blog/ritual-de-outono-sound-healing-em-gondifelos-meditacao-guiada-ao-som-de-tacas-tibetanas-e-de-cristal',
  data: '7 de novembro · 17h30 às 19h',
  titulo: 'Ritual de Outono & Sound Healing',
  subtitulo: 'Meditação ao som de taças tibetanas e de cristal',
  detalhes: ['Desapego e enraizamento', 'Sessão intimista', '25 €', 'Vagas limitadas'],
  local: 'No espaço Márcia Monteiro',
  extra: 'Inclui momento do chá',
};
